import {
  GENERATE_MERCHANT_KEY_SUCCESS,
  GENERATE_MERCHANT_KEY_FAILED,
  RESET_GENERATE_MERCHANT_KEY,
  LOADING_GENERATE_MERCHANT_KEY,
  NETWORK_ERROR_GENERATE_MERCHANT_KEY,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  success: false,
  data: {},
  networkError: "",
  invalidRequest: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GENERATE_MERCHANT_KEY: {
      return {
        ...state,
        isLoading: true,
        failed: false,
        success: false,
        invalidRequest: false,
        data: {},
      };
    }
    case GENERATE_MERCHANT_KEY_FAILED: {
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: false,
        data: {},
      };
    }
    case GENERATE_MERCHANT_KEY_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        data: action.payload,
      };
    }
    case NETWORK_ERROR_GENERATE_MERCHANT_KEY: {
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: true,
        networkError: "Something went wrong!",
        data: {},
      };
    }
    case RESET_GENERATE_MERCHANT_KEY: {
      return (state = initialState);
    }

    default:
      return state;
  }
};
